import cx from 'classnames'
import type { ReactNode } from 'react'

import { useAnimatedBadges } from 'src/hooks/useAnimatedBadges'

import type { BadgeSlotClasses } from './types'

type Props = {
  animatedBadges: ReactNode[]
  staticItem?: ReactNode | null
  classes: BadgeSlotClasses
}

export function BadgeSlot({ animatedBadges, staticItem, classes }: Props) {
  const { rotationIndex, animationPhase } = useAnimatedBadges(animatedBadges.length)

  if (staticItem) {
    return <div className={classes.rotatingTagSlot}>{staticItem}</div>
  }

  if (!animatedBadges.length) {
    return null
  }

  return (
    <div
      className={cx(
        classes.rotatingTagSlot,
        animationPhase === 'out' && classes.tagOut,
        animationPhase === 'in' && classes.tagIn,
      )}
    >
      {animatedBadges[rotationIndex]}
    </div>
  )
}

export type { BadgeSlotClasses }
